@if (slideAuthorFacade.currentSelectedSlideImage$ | async; as image) {
  <!-- Header -->
  @if ({
    media: image.media ? (slideAuthorFacade.media$(image.media) | async) : null
  }; as mediaData) {
    <medsurf-slide-edit-header
      [icon]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.IMAGE"
      [label]="'# ' + image.sequenceNumber"
    [type]="'enum.media.' + (mediaData.media !== null ? mediaData.media.type : 'MediaUnknown')"></medsurf-slide-edit-header>
  }
  <!-- Content -->
  <div #edit_overlay_template_scroll_panel
    class="flex flex-1 overflow-auto justify-content-center">
    <!-- Accordion -->
    <p-accordion [activeIndex]="[0, 1, 2]"
      [multiple]="true"
      styleClass="no_border"
      class="w-full h-full ml-3 mr-3">
      <p-accordionTab [header]="'global.general' | translate"
        headerStyleClass="uppercase">
        <div class="flex flex-column align-items-center">
          <!-- Image Form -->
          @if (imageForm) {
            <medsurf-design-form-control-form
              [formGroup]="imageForm"
              [class]="'w-full'"
              (onSubmit)="onSubmit()">
              <!-- Media -->
              <medsurf-media-library-modal [mediaId]="imageForm.value.media"
                [label]="'global.image'"
                                           [allowedTypes]="[
                                              FlatModels.MediaEntityModels.MediaType.enum.MediaImage, 
                                              FlatModels.MediaEntityModels.MediaType.enum.MediaDeepzoom,
                                              FlatModels.MediaEntityModels.MediaType.enum.MediaVideo,
                                              FlatModels.MediaEntityModels.MediaType.enum.MediaAudio
                                           ]"
                (mediaChange)="onMediaChange($event)"
              [class]="'w-full align-self-start'"></medsurf-media-library-modal>
            </medsurf-design-form-control-form>
          }
          <!-- Media Link -->
          <medsurf-slide-edit-media-link [class]="'w-full'"></medsurf-slide-edit-media-link>
        </div>
      </p-accordionTab>
      <p-accordionTab [header]="'global.layout' | translate"
        headerStyleClass="uppercase">
        <!-- Background Form -->
        @if (backgroundForm) {
          <medsurf-design-form-control-form
            [formGroup]="backgroundForm"
            [class]="'w-full'"
            (onSubmit)="onBackgroundSubmit()">
            <!-- Background Color -->
            <medsurf-design-form-control-input-color-picker [control]="backgroundForm.controls.color"
              [label]="'global.background_color'"
              [class]="'w-full'"
            (valueChange)="onBackgroundSubmit()"></medsurf-design-form-control-input-color-picker>
          </medsurf-design-form-control-form>
        }
      </p-accordionTab>
      <p-accordionTab [header]="'global.relation' | translate"
        headerStyleClass="uppercase">
        <div class="flex flex-column row-gap-2 align-items-center">
          <!-- Annotations -->
          <medsurf-slide-edit-image-annotation-form [class]="'w-full'"></medsurf-slide-edit-image-annotation-form>
          <!-- POIs -->
          <medsurf-slide-edit-image-poi-form [class]="'w-full'"></medsurf-slide-edit-image-poi-form>
        </div>
      </p-accordionTab>
    </p-accordion>
  </div>
}